import { createFileRoute } from '@tanstack/react-router'
import AgreementTerms from 'Royalty/components/Agreement/AgreementTerms'

export const Route = createFileRoute('/royalty_/agreement/$id/terms/')({
    component: AgreementTerms,
})
